export default {
  categoryInfo: {
    mainTitle: 'Ferdi Kaza Sigortası',
    description: {
      title: 'Ferdi Kaza Sigortası Nedir?',
      content: [
        'Ferdi Kaza Sigortası kaza sonucunda ölüm, sürekli maluliyet, tedavi masrafları ve gündelik kazalara karşı tazminat teminatlarıyla beraber nakil hizmetleri bu sigorta ürününde güvence altındadır. ',
        'Ferdi kaza sigortası ile tüm bireyler ani oluşacak kazalara karşı hem kendilerini hem de dolaylı bile olsa ailelerini poliçe kapsamında risklere karşı korumuş olurlar. Beklenmedik durum poliçesidir.'
      ]
    },
    subContent: {
      title: 'Ferdi Kaza Sigortası Kapsamı ve Türleri Nelerdir?  ',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigorta kapsamı sizin kendi iradeniz dışında oluşabilecek kazaları kapsamaktadır. Kaza adı altında oluşabilecek risklere karşı bu poliçe ile güvence altında olacaksınız. Teminat türleri poliçede belirlenen limitlere göre değişmektedir. Poliçenin tazminat kapsamı, kaza sonucu sigortalıya ödenecek limitler poliçe detayına göre teklif aşamasında, sigortalı talebine göre belirlenmektedir. ',
          subList: null
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Ferdi Kaza Sigortası Teminatları Nelerdir? ',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortası limitleri belirlendiği gibi birde değişmeyen, her poliçede sabit olan teminatlar mevcuttur. Bu teminatlar;',
          subList: [
            'Vefat Teminatı',
            'Sürekli Sakatlık Teminatı',
            'Gündelik Teminat',
            'Tedavi Masrafları Teminatı'
          ]
        },
        {
          paragraph:
            'Ferdi Kaza Sigortası ürünlerinde bu teminatlar, genel teminat arasında yer almaktadır',
          subList: null
        }
      ]
    },
    {
      title: 'Kaza Sonucu Vefat Teminatı Nedir? ',
      content: [
        {
          paragraph:
            'Poliçede belirlenen limitler dâhilinde kaza, sigortalının kaza tarihi itibari ile 1 sene içinde vefatına sebep olduğu takdirde, sigorta bedeli poliçede belirlenen menfaatçilere, yoksa kanuni hak sahibi olan kişilere ödenir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Kaza Sonucu Tedavi Masrafları Teminatı Nedir? ',
      content: [
        {
          paragraph:
            'Kaza sonucu ortaya çıkan; doktor, ilaç, hastane gibi tedavi masrafları bu teminattan karşılanır. Poliçede yazılı Tedavi Masrafları limitine kadar sigorta şirketi ödeme yapar. ',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph: 'Ferdi Kaza Sigortaları, sizin etkiniz dışında oluşan kazalara maruz kalmanız durumlarında hayatınıza normal devam edebilmeniz için sizleri teminat altına alan sigorta ürünüdür. Başınıza gelen bir kazadan sonra, sürekli maluliyet durumunda her hangi bir uzuv kaybında veya uzvunuzu kullanamamanız gibi bir durum sonrasında çalışamama ya da iş görmezlik gibi bir durum oluşursa maddi olanaklarınızın devam edebilmesi için poliçenizde belirli teminatların ödemesini alarak yaşamınıza devam edebilmenizi sağlar.',
          subList: null
        },
        {
          paragraph:
            'Poliçenin kapsadığı bir kazadan dolayı vefat durumu yaşanır ise, tazminat poliçenizde ki menfaatçisine eğer yoksa kanuni varislere ödeme yapılır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigortası Kimlere Yapılır?',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortaları, 18-64 yaş arası her birey için yapılabilir. 18 yaş altı bireylerde, ailesindeki vasilerinden biri sigorta ettiren belirtilerek poliçeleştirilebilir.',
          subList: null
        },
        {
          paragraph:
            'Ferdi kaza sigortası yaş sınırı sigorta şirketlerine göre farklılık gösterebilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigortasının Coğrafi Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortaları Türkiye sınırları içinde geçerli olduğu gibi, teminat eklenmesi durumunda yurt dışında da geçerli olabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortası, bireyler için yapılması zorunlu değildir.',
          subList: null
        },
        {
          paragraph:
            'Sadece tur şirketiniz var ise, seyahat edecek bireylerin düzenlediğiniz turlarda oluşacak kazalara karşı ferdi kaza sigortalarını yaptırmanız sizin sorumluluğunuzdadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Hayat Sigortası İle Ferdi Kaza Sigortası Arasındaki Farklar Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi Kaza ve Hayat Sigortaları arasındaki fark, hayat sigortası sigortalıyı her türlü ölüm durumuna karşı güvence altına alabilirken, Ferdi Kaza Sigortası sigortalıyı, vefat nedeninin kaza sonucu olmasına karşı güvence altına alır.',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigorta Teminat Tutarı Nasıl Belirlenmektedir?',
      content: [
        {
          paragraph: 'Ferdi Kaza Sigortası kapsamında sigorta bedeli, sigortalı kişinin yaşı ve mesleki bilgilerini baz alarak belirli maddeler halinde teminat sunar. ',
          subList: null
        },
        {
          paragraph:
            'Poliçelerde ödenecek tazminatların miktarları, poliçeleştirme aşamasında tarafların uzlaşması sonucunda belirlenir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Kalp Krizi Ferdi Kazaya Girer Mi?',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortalarında kalp krizi kalp teminat kapsamında değildir. Fakat kaza sırasında kalp krizi geçirmeniz durumunda poliçede teminat kapsamından fayda sağlanabilir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Deprem, Ferdi Kaza Sigortasına Dâhil Midir?',
      content: [
        {
          paragraph:
            'Deprem gibi doğal afetler ferdi kaza sigortalarında, teminat kapsamında değildir. Fakat ek kloz eklenerek, teminat kapsamına dâhil edilebilir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigortası Trafik Kazasını Kapsar Mı? ',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortaları trafik kazalarını da kapsamaktadır. Kaza oluşum nedeni belirtilen teminatlar kapsamında ise tüm limitleri ile ödemenizi alabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigortası İş Kazasını Karşılar Mı? ',
      content: [
        {
          paragraph:
            'İş yerinde yaşayacağınız ani kazalarda da Ferdi Kaza Sigortanız varsa poliçenizden faydalanabilirsiniz. Poliçeniz kapsamında teminat sağlanır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigortası Gider Yazılır Mı?',
      content: [
        {
          paragraph:
            'Şirketiniz bünyesinde çalışanlar için yaptıracağınız Ferdi Kaza Sigortalarını, şirketiniz için vergiden indirim alınması, Vergi Usul Kanunun 40 ve 41. Maddesinde hükümlerine uygun olarak belirtilmiştir.',
          subList: null
        }
      ]
    },
    {
      title: ' Ferdi Kaza Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortası hesaplamalarında kişinin yaşı, mesleği, yer aldığı konumdaki risklerin hepsi hesaplanarak poliçe primi belirlenir.',
          subList: null
        },
        {
          paragraph:
            'Poliçede yer alan teminatlar ve ödemeler, poliçeleştirme aşamasında taraflar arasında uzlaşılarak belirlenir.  Özellikle poliçe kapsamına istenilen bir ek teminat varsa primlerin yükselişi de söz konusu olacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Sigortası Fiyatları Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortalarında fiyatlar, poliçe teminatlarına, karşıladığı risklere, bedellere göre değişiklik gösterir. Her sigorta şirketinin karşıladığı kazalar, limitler farklı olması nedeni ile şirketlerde de poliçe primleri farklıdır. Sabit bir poliçe primi belirtmek yanlıştır. En doğru fiyatları karşılaştırmak için teklif almanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Ferdi Kaza Sigortası Alınır Mı?',
      content: [
        {
          paragraph:
            'Ferdi Kaza Sigortası yaptırmak isteyen müşterilerimiz online poliçe yapılabilir. ',
          subList: null
        },
        {
          paragraph:
            'Limitler ve teminatlar belirlenmesi dahilinde kendi poliçenizi kolayca oluşturabilirsiniz.  ',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Koltuk Ferdi Kaza Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu Koltuk Ferdi Kaza Sigortası sınırlarımız içinde ve dışında yolcu nakli kapsamı ile seyahat eden kişileri, sürücüleri ve görevlileri, yolculuğun başlangıcı ve bitişi arasındaki süreler, duraksamalar dâhil seyahat süresi boyunca oluşacak tüm riskleri teminat altına alan sigorta ürünüdür. ',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Koltuk Ferdi Kaza Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph: 'Zorunlu Koltuk Ferdi Kaza Sigortası, ticari amaç ile seyahat hizmeti veren şirket görevlilerinin, seyahat boyunca hizmet verdiği kişileri oluşabilecek her kazaya karşı teminat altına aldığı sigorta ürünüdür. ',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Koltuk Ferdi Kaza Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Ölüm Teminatı',
            'Sakatlık Teminatı',
            'Tedavi Giderleri Teminatı'
          ]
        },
        {
          paragraph: 'Poliçe teminat kapsamında oluşan tüm kazalarda, yukarıdaki teminatların hepsinden faydalanabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Ferdi Kaza Sigortası Kimler Yaptırabilir?',
      content: [
        {
          paragraph:
            'Zorunlu Ferdi Kaza Sigortasını, yurtiçi ve yurt dışı yolcu taşımacılığı yaptıran her firma ve bireyler yaptırabilir. Kişilerin kazaya karşı güvenliğini sağlamak amaçlıyla yaptırılmalıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Koltuk Ferdi Kaza Sigortasının Coğrafi Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu Koltuk Ferdi Kaza Sigortasının coğrafi bir sınırlaması yoktur. Türkiye içinde ve yurt dışında poliçe kapsamından teminat kapsamında faydalanabilirler. ',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Koltuk Ferdi Kaza Sigortası Teminat Tutarı Nasıl Belirlenmektedir?',
      content: [
        {
          paragraph:
            'Zorunlu Koltuk Ferdi Kaza Sigortası fiyatları, poliçenin içerdiği teminat ve hangi riskleri kapsadığına göre değişiklik göstermektedir. Her poliçede teminat detayına göre tutarlar değişmektedir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Koltuk Ferdi Kaza Sigortası Gider Yazılır Mı?',
      content: [
        {
          paragraph:
            'Zorunlu Koltuk Ferdi Kaza Sigortası yaptıran şirketler bunu ürünü yaptırmakla yükümlü oldukları için, yapılan poliçeleri gider olarak gösterebilirler.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Koltuk Ferdi Kaza Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Zorunlu Koltuk Ferdi Kaza Sigortaları teminatlarına ve risk durumuna göre değişiklik göstermektedir. Doğru fiyatları değerlendirmek için teklif alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Zorunlu Koltuk Ferdi Kaza Sigortası Alınır Mı?',
      content: [
        {
          paragraph:
            'Online zorunlu koltuk sigortası satın almak için teklif al formundan bilgilerinizi uzmanlarımıza iletmeniz yeterlidir.',
          subList: null
        }
      ]
    }
  ]
}
